import type { SVGProps } from "react";

export const Ticktick = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    height="500"
    viewBox="0 0 500 500"
    width="500"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Ticktick</title>
    <circle cx="250" cy="250" fill="white" r="250" />
    <g clipPath="url(#clip0_3252_1864)">
      <path
        clipRule="evenodd"
        d="M197.349 207.413L168.156 242.949L237.293 299.638C239.645 301.569 242.357 303.014 245.272 303.889C248.187 304.765 251.247 305.053 254.274 304.737C257.301 304.421 260.235 303.507 262.906 302.049C265.577 300.59 267.933 298.616 269.835 296.241L393.843 141.406L357.944 112.658L248.493 249.325L197.349 207.413Z"
        fill="#FFB000"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M250 385.625C175.215 385.625 114.375 324.785 114.375 250C114.375 175.215 175.215 114.375 250 114.375V75C153.503 75 75 153.503 75 250C75 346.497 153.503 425 250 425C346.497 425 425 346.497 425 250H385.625C385.625 324.785 324.785 385.625 250 385.625Z"
        fill="#4772FA"
        fillRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="clip0_3252_1864">
        <rect
          fill="white"
          height="350"
          transform="translate(75 75)"
          width="350"
        />
      </clipPath>
    </defs>
  </svg>
);

export default Ticktick;
